import React, { useState, useEffect } from "react";
import { NavLink, Link, useLocation } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { siteData } from "../mock";

const navItems = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Services", to: "/services" },
  { label: "Properties", to: "/properties" },
  { label: "Gallery", to: "/gallery" },
  { label: "Contact", to: "/contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [location.pathname]);

  return (
    <>
      <header className={`fixed top-0 inset-x-0 z-50 bg-white/95 backdrop-blur border-b border-neutral-200 transition-shadow ${scrolled ? "shadow-[0_2px_14px_rgba(0,0,0,0.06)]" : ""}`}>
        <div className="max-w-7xl mx-auto px-5 md:px-8 py-3 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3 group">
            <img src={siteData.brand.logo} alt="JK Estates logo" className="h-10 md:h-12 w-auto object-contain select-none" draggable={false} />
            <div className="text-left leading-tight">
              <div className="font-serif text-[19px] md:text-[22px] text-neutral-900 leading-none">{siteData.brand.name}</div>
              <div className="text-[9.5px] md:text-[10.5px] tracking-[0.25em] text-[#b88b4a] mt-1.5">{siteData.brand.tagline}</div>
            </div>
          </Link>

          <nav className="hidden lg:flex items-center gap-9">
            {navItems.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.to === "/"}
                className={({ isActive }) => `text-[13.5px] tracking-wide transition-colors hover:text-[#b88b4a] ${isActive ? "text-[#b88b4a]" : "text-neutral-800"}`}
              >
                {n.label}
              </NavLink>
            ))}
            <a href={`tel:${siteData.brand.primaryPhoneRaw}`} className="btn-dark inline-flex items-center gap-2 px-5 py-2.5 text-[12.5px] tracking-wide">
              <Phone className="w-4 h-4" /> Call {siteData.brand.primaryPhone}
            </a>
          </nav>

          <button onClick={() => setOpen(!open)} className="lg:hidden w-10 h-10 flex items-center justify-center text-neutral-900" aria-label="Menu">
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </header>

      {/* Spacer so fixed header does not overlap content */}
      <div className="h-[68px] md:h-[76px]" aria-hidden />

      {/* Mobile menu */}
      <div className={`lg:hidden fixed inset-x-0 top-[68px] z-40 bg-white transition-all duration-300 overflow-hidden ${open ? "max-h-[560px] border-b border-neutral-200 shadow-[0_10px_20px_rgba(0,0,0,0.06)]" : "max-h-0"}`}>
        <div className="px-5 py-1">
          {navItems.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.to === "/"}
              className={({ isActive }) => `block w-full text-left py-4 text-[16px] border-b border-neutral-200 transition-colors ${isActive ? "text-neutral-900 font-medium" : "text-neutral-700"}`}
            >
              {n.label}
            </NavLink>
          ))}
          <a href={`tel:${siteData.brand.primaryPhoneRaw}`} className="btn-dark mt-5 mb-5 w-full flex items-center justify-center gap-2 py-4 text-[14.5px] tracking-wide">
            <Phone className="w-4 h-4" /> Call {siteData.brand.primaryPhone}
          </a>
        </div>
      </div>
    </>
  );
}
